export default function guest({ next }) {
    // if(store.getters.auth.loggedIn){
    if (window.localStorage.getItem("rep")) {
        return next({
            name: 'admin'
        })
    }

    return next()
}